import React, { useMemo } from 'react';
import { Badge, Dropdown } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { collect } from 'collect.js';
import { useSelector } from 'react-redux';
import useApiClient from '../../hooks/api/useApiClient';

export default function NotificationsDropdown() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Layout:NotificationsDropdown' });

  const { notifications } = useSelector((store) => store.initialData);

  const { NotificationsManager } = useApiClient();

  const unseen = useMemo(() => collect(notifications).whereNull('read_at'), [notifications]);

  const resetNotifications = () => {
    unseen.each((item) => NotificationsManager.delete(item.id));
  };

  const renderPanel = () => (
    <div className="bg-white rounded-lg shadow min-w-[280px] py-xs">
      <div className="text-center p-md">
        <strong>{t('title', { length: unseen.count() })}</strong>
      </div>
      {notifications?.map((item) => (
        <div key={`notification-${item.id}`} className="px-md py-xs">
          <div className="font-semibold truncate" style={{ color: '#000' }}>
            {t(`notifications.titles.${item.type}`)}
          </div>
          <div className="text-sm text-gray-500 truncate">{t(`notifications.descriptions.${item.type}`)}</div>
        </div>
      ))}
    </div>
  );

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      onOpenChange={(open) => open && resetNotifications()}
      popupRender={renderPanel}
    >
      <span className="cursor-pointer px-md">
        <Badge count={unseen.isNotEmpty() ? unseen.count() : 0} size="small">
          <BellOutlined className="text-lg" />
        </Badge>
      </span>
    </Dropdown>
  );
}
